module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('el-date-picker', {
    staticStyle: {
      "float": "right",
      "width": "220px"
    },
    attrs: {
      "type": "daterange",
      "clearable": false,
      "size": "mini"
    },
    model: {
      value: (_vm.filters.date),
      callback: function($$v) {
        _vm.$set(_vm.filters, "date", $$v)
      },
      expression: "filters.date"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "header-title m-t-0 m-b-20"
  }, [_vm._v("Rappels du jour et passés")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row m-b-10"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('el-select', {
    staticClass: "form-control",
    attrs: {
      "clearable": "",
      "multiple": "",
      "placeholder": "Filtrer par type de rappel"
    },
    model: {
      value: (_vm.filters.categories),
      callback: function($$v) {
        _vm.$set(_vm.filters, "categories", $$v)
      },
      expression: "filters.categories"
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('el-option', {
      key: category.id,
      attrs: {
        "label": category.name,
        "value": category.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('el-select', {
    staticClass: "form-control",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Filtrer par client ou prospect"
    },
    model: {
      value: (_vm.filters.customer),
      callback: function($$v) {
        _vm.$set(_vm.filters, "customer", $$v)
      },
      expression: "filters.customer"
    }
  }, _vm._l((_vm.models.customers), function(customer) {
    return _c('el-option', {
      key: customer.id,
      attrs: {
        "label": customer.name,
        "value": customer.id
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row m-b-10"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "warning",
      "size": "small",
      "disabled": _vm.selected.length === 0
    },
    on: {
      "click": _vm.openMoveReminders
    }
  }, [_vm._v("Modifier la selection")])], 1)]), _vm._v(" "), _c('list-timetable', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "min-height": "100px"
    },
    attrs: {
      "from": _vm.filters.date[0],
      "to": _vm.filters.date[1],
      "events": _vm.events,
      "reverse": true
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(props) {
        return [_c('header', [_c('el-checkbox', {
          staticStyle: {
            "margin-bottom": "-4px"
          },
          attrs: {
            "checked": false,
            "data-block-day-id": _vm.moment(props.day.date).format('YYYY-MM-DD')
          },
          on: {
            "change": _vm.handleDayCheckboxChanges
          }
        }), _vm._v("\n        " + _vm._s(_vm._f("moment")(props.day.date, "dddd DD")) + "\n        " + _vm._s(_vm._f("moment")(props.day.date, "MMMM")) + "\n        "), _c('span', [_vm._v(_vm._s(_vm._f("moment")(props.day.date, "DD/MM/YYYY")))])], 1)]
      }
    }, {
      key: "default",
      fn: function(props) {
        return [_c('div', {
          staticClass: "timetable-name"
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-5"
        }, [_c('el-checkbox', {
          attrs: {
            "checked": false,
            "data-day-id": _vm.moment(props.event.date.from).format('YYYY-MM-DD'),
            "data-id": props.event.meta.reminder.id
          },
          on: {
            "change": _vm.handleCheckboxChanges
          }
        }), _vm._v(" "), (props.event.meta.reminder.meeting) ? _c('i', {
          staticClass: "fa fa-calendar-check-o"
        }) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v(_vm._s(props.event.title))]), _vm._v(" "), (props.event.meta.reminder.meeting) ? _c('span', [_vm._v(" à " + _vm._s(_vm._f("moment")(props.event.date.from, 'H:mm')))]) : _vm._e(), _vm._v(" "), (props.event.description && props.event.description.trim() !== '') ? _c('span', [_vm._v(" : " + _vm._s(props.event.description))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
          staticClass: "col-md-5"
        }, [_c('customer', {
          attrs: {
            "item": _vm.models.customers.find(function (customer) { return customer.id === props.event.meta.reminder.customer_id; })
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('div', {
          staticClass: "pull-right"
        }, [_c('span', {
          staticClass: "timetable-name"
        }, [_c('el-button', {
          directives: [{
            name: "edit",
            rawName: "v-edit:reminder",
            value: (props.event.meta.reminder),
            expression: "props.event.meta.reminder",
            arg: "reminder"
          }],
          attrs: {
            "type": "warning",
            "size": "mini",
            "icon": "el-icon-edit",
            "circle": ""
          }
        }), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "delete",
            rawName: "v-delete:reminder",
            value: (props.event.meta.reminder),
            expression: "props.event.meta.reminder",
            arg: "reminder"
          }],
          attrs: {
            "type": "danger",
            "size": "mini",
            "icon": "el-icon-close",
            "circle": ""
          }
        })], 1)])])])])]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b6f77ff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Widgets/Reminders/RemindersListWidget.vue
// module id = 686
// module chunks = 1